"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

export function ReadingProgress() {
  const pathname = usePathname();
  const barRef = useRef<HTMLDivElement>(null);

  const isArticlePage =
    pathname.startsWith("/guides/") ||
    pathname.startsWith("/cheat-sheets/apa") ||
    pathname.startsWith("/cheat-sheets/mla") ||
    pathname.startsWith("/cheat-sheets/chicago");

  useEffect(() => {
    if (!isArticlePage) {
      return;
    }

    let rafId = 0;

    function update() {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0 && barRef.current) {
        const pct = Math.min(scrollTop / docHeight, 1);
        barRef.current.style.transform = `scaleX(${pct})`;
      }
    }

    function handleScroll() {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    update();
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isArticlePage]);

  if (!isArticlePage) {
    return null;
  }

  return (
    <div className="fixed top-0 right-0 left-0 z-[60] h-0.5">
      <div
        className="h-full w-full origin-left bg-primary"
        ref={barRef}
        style={{ transform: "scaleX(0)", willChange: "transform" }}
      />
    </div>
  );
}
